import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { RetailerChangePassword } from '../../../../core';
import { AccountService } from '../../../account.service';

class ChangeRetailerPassword implements ng.IController {
    public static $inject = ['notificationService', 'accountService'];

    public waiting: boolean = false;
    public confirmPassword: string  = null;
    public changePassword: RetailerChangePassword = {
        Password: null,
        NewPassword: null
    };
    public changePasswordForm: ng.IFormController;
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    constructor(
        public notificationService: NotificationService,
        public accountService: AccountService
    ) {
    }

    public $onDestroy(): void {
        this.confirmPassword = null;
        this.changePassword = null;
        this.changePasswordForm = null;
    }

    public closeDialog() {
        this.modalInstance.close();
    }

    public changePasswordModel() {
        this.changePasswordForm.confirmPassword.$setValidity('match', this.changePassword.NewPassword === this.confirmPassword);
    }

    public async submitChangePassword() {
        if (!this.changePasswordForm.$dirty && this.changePasswordForm.$invalid) {
            this.changePasswordForm.$setPristine();
            return;
        } else if (this.changePasswordForm.$dirty && this.changePasswordForm.$invalid) {
            return;
        }

        this.waiting = true;
        this.notificationService.showWaitingMessage();

        try {
            await this.accountService.updatePassword(this.changePassword);
            this.notificationService.showSuccessMessage();
            this.modalInstance.close();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }
}

angular.module('naut').component('changeRetailerPassword', {
    template: require('./change-retailer-password.component.html'),
    controller: ChangeRetailerPassword,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '=',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/components/profile/change-retailer-password/change-retailer-password.component.ts